<template>
    <div
        class="flex gap-16"
        :data-component="$options.name"
    >
        <cs-input-field
            v-model="currentValues.min"
            class="w-full"
            :label="minLabel"
            :regex="regexNumberOnly"
            @blur="onInputTrigger"
            @keyup.enter="onInputTrigger"
        />
        <cs-input-field
            v-model="currentValues.max"
            class="w-full"
            :label="maxLabel"
            :regex="regexNumberOnly"
            @blur="onInputTrigger"
            @keyup.enter="onInputTrigger"
        />
    </div>
</template>

<script lang="ts" src="./MsFilterMinMax.ts" />
